import keyMirror from '../../../utilities/keymirror';

const ActionTypes = keyMirror({
  CREATE_REFUND_FAILURE: null,
  CREATE_REFUND_REQUEST: null,
  CREATE_REFUND_SUCCESS: null,
  CREATE_FRAUD_REVIEW_DECISION_SUCCESS: null,
  CREATE_FRAUD_REVIEW_DECISION_FAILURE: null,
  CREATE_FRAUD_REVIEW_DECISION_REQUEST: null,
  FETCH_ALLOCATIONS_REQUEST: null,
  FETCH_ALLOCATIONS_SUCCESS: null,
  FETCH_ALLOCATIONS_FAILURE: null,
  FETCH_INVOICES_REQUEST: null,
  FETCH_INVOICES_SUCCESS: null,
  FETCH_INVOICES_FAILURE: null,
  FETCH_ORDER_VERSIONS_REQUEST: null,
  FETCH_ORDER_VERSIONS_SUCCESS: null,
  FETCH_ORDER_VERSIONS_FAILURE: null,
  FETCH_ORDERS_REQUEST: null,
  FETCH_ORDERS_SUCCESS: null,
  FETCH_ORDERS_FAILURE: null,
  FETCH_ORDER_DETAIL_FAILURE: null,
  FETCH_ORDER_DETAIL_REQUEST: null,
  FETCH_ORDER_DETAIL_SUCCESS: null,
  FETCH_ORDER_DETAILS_FAILURE: null,
  FETCH_ORDER_DETAILS_REQUEST: null,
  FETCH_ORDER_DETAILS_SUCCESS: null,
  FETCH_ORDER_NOTES_FAILURE: null,
  FETCH_ORDER_NOTES_REQUEST: null,
  FETCH_ORDER_NOTES_SUCCESS: null,
  FETCH_REFUND_ORDER_SUMMARY_FAILURE: null,
  FETCH_REFUND_ORDER_SUMMARY_NOT_FOUND: null,
  FETCH_REFUND_ORDER_SUMMARY_REQUEST: null,
  FETCH_REFUND_ORDER_SUMMARY_SUCCESS: null,
  FETCH_RETURN_ORDER_SUMMARY_FAILURE: null,
  FETCH_RETURN_ORDER_SUMMARY_REQUEST: null,
  FETCH_RETURN_ORDER_SUMMARY_SUCCESS: null,
  HIDE_APPROVE_FRAUD_REVIEW_DIALOG: null,
  HIDE_DECLINE_FRAUD_REVIEW_DIALOG: null,
  HIDE_REFUND_FORM_DIALOG: null,
  HIDE_ORDER_TRACKING_DETAIL_DIALOG: null,
  SHOW_APPROVE_FRAUD_REVIEW_DIALOG: null,
  SHOW_DECLINE_FRAUD_REVIEW_DIALOG: null,
  SHOW_ORDER_TRACKING_DETAIL_DIALOG: null,
  SHOW_REFUND_FORM_DIALOG: null,
  SET_NOTIFICATION: null,
  RESET_NOTIFICATION: null,
  RESET_REFUND_ORDER_SUMMARY: null,
  UPDATE_REFUND_AMOUNT: null,
  UPDATE_DISPUTE_REQUEST: null,
  UPDATE_DISPUTE_SUCCESS: null,
  UPDATE_DISPUTE_FAILURE: null,
  CLEAR_REFUND_AMOUNT: null,
  ORDER_NOTE_CREATED: null,
  ORDER_NOTE_EDITED: null,
  ORDER_NOTE_DELETED: null,
  DEBUG_TRANSACTIONS_REQUEST: null,
  DEBUG_TRANSACTIONS_SUCCESS: null,
  DEBUG_TRANSACTIONS_FAILURE: null,
}, 'CUSTOMER_SERVICE');

export default ActionTypes;
